import React from 'react';
import {Button,Icon} from "antd"
import "./index.less"
// 行业动态
// console.log('HomeHangYeDongtai',window.apiObj.hangYeList);
var hangYeList = window.apiObj.hangYeList

function HomeHangYeDongtai() {
  
  return (
    <div style={{marginTop:'-20px'}}>
     {
        hangYeList.map((item, index) => {
          if (index<3) {
            return (
              // #/detail?name=行业动态&title=教育部办公厅关于进一步做好普通中小学招生入学工作的通知
              <a className='hangYeDongTai-a' key={index} href={'#/detail?page=&type=news&name=行业动态&title='+item.title}>
                <div className="hangYeDongTai-wrapper">
                  <div className="month-item">
                    <div className={'month'}>0{index+1}</div>
                    <div className="year">{item.date}</div>
                  </div>
                  <div  className="content-item">
                    <h3 className='title line-ellipsis'>{item.title}</h3>
                    <div className="desc">{item.title}</div>
                  </div>
                </div>
                </a>
            )
          }

        })
      }
      <div style={{marginLeft:'20px',marginTop:'14px'}}>
        <Button href='#/dongtai' type='primary' ghost 
        style={{height:'38px',width: '656px',lineHeight:'38px',borderColor:'#c0c0c0',color:'rgb(74 74 74)'}}>查看更多<Icon type="right" /></Button>
      </div>
    </div>
  );
}

export default HomeHangYeDongtai;
